import { defineSemanticTokens } from '@chakra-ui/react/styled-system';

import { withSlashes } from '../themeUtils';

const shadows = defineSemanticTokens.shadows(
  withSlashes({
    elevation: {
      lg: {
        value: {
          _light: '0 0.125rem 1.5rem 0 rgba(0, 0, 0, 0.08)',
        },
      },
      md: {
        value: {
          _light: '0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.06)',
        },
      },
      sm: {
        value: {
          _light: '0 0.125rem 0.25rem 0 rgba(0, 0, 0, 0.06)',
        },
      },
      tooltip: {
        value: {
          _light: '0 0.0625rem 0.1875rem 0 rgba(0, 0, 0, 0.2)',
        },
      },
    },
    inset: {
      field: {
        value: {
          _light: '0 0.125rem 0.1875rem 0 rgba(0, 0, 0, 0.1) inset',
        },
      },
    },
  }),
);

export default shadows;
